import { render, staticRenderFns } from "./Form1.vue?vue&type=template&id=587edbd4&scoped=true&"
import script from "./Form1.vue?vue&type=script&lang=js&"
export * from "./Form1.vue?vue&type=script&lang=js&"
import style0 from "./Form1.vue?vue&type=style&index=0&id=587edbd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587edbd4",
  null
  
)

export default component.exports